import { createApp, h } from 'vue'
import NykButton from './NykButton.vue'
import handleComponentProps from '../../foundation/js/utils/handleComponentProps'

const el = '.nyk-component--nyk-button'

function extractSlotsFromDOM(dom) {
    const slots = {};
    dom.querySelectorAll('template').forEach(tpl => {
        // Only support icon slot for demo markup
        let name = 'icon';
        slots[name] = tpl.innerHTML;
        tpl.remove();
    });
    // Default slot: everything else
    const defaultContent = dom.innerHTML.trim();
    if (defaultContent) {
        slots.default = defaultContent;
    }
    return slots;
}

export default function () {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((ButtonDOM) => {
            const props = handleComponentProps(NykButton, ButtonDOM)
            const slots = extractSlotsFromDOM(ButtonDOM)
            // Clear the DOM so Vue can mount cleanly
            ButtonDOM.innerHTML = ''
            const app = createApp({
                render() {
                    // Inject slot content directly as raw HTML (no wrapper)
                    const slotRenderers = {};
                    Object.entries(slots).forEach(([name, content]) => {
                        slotRenderers[name] = () => h('div', { innerHTML: content, style: 'display: contents' });
                    });
                    return h(NykButton, props, slotRenderers);
                }
            });
            app.mount(ButtonDOM);
        })
    }
}
